const UserLangs = {
  userList: {
    title: "Danh sách nhân viên",
  },
  userUpdate: {
    title: "Cập nhật thông tin nhân viên",
    form: {
      lastName: "Tên",
      firstName: "Họ",
      userName: "Username",
      email: "Email",
      password: "Mật khẩu",
      roles: "Quyền",
      create: "Tạo nhân viên",
      update: "Cập nhật",
    },
    updateSuccess: "Cập nhật thành công",
  },
  error: {
    userList: {
      message: "Lỗi danh sách nhân viên",
    },
    reportSummary: {
      message: "Lỗi thống kê doanh thu nhân viên",
    },
    updateUser: {
      message: "Cập nhật lỗi",
    },
    createUser: {
      message: "Tạo nhân viên lỗi",
    },
  },
  userAdd: {
    title: "Thêm nhân viên",
    createSuccess: "Tạo thành công",
  },
};
export default UserLangs;
